import cookies from 'react-cookies';

const config = {
  path: process.env.REACT_APP_PUBLIC_URL || '/',
};
export default {
  load: name => cookies.load(name),
  save: (name, data, callback = () => null) => {
    cookies.remove(name);
    cookies.save(name, data);
    callback();
  },
  remove: (name, callback = () => null) => {
    cookies.remove(name);
    callback();
  },
  updateUser: data => {
    let temp = cookies.load('userInfo') || {};
    cookies.remove('userInfo');
    cookies.save('userInfo', { ...temp, ...data });
  },
  getUserInfo: () => {
    let userInfo = cookies.load('userInfo');
    return userInfo;
  },
};
